export abstract class EntityBase {
    Id: number = 0;
    NetId: string = '00000000-0000-0000-0000-000000000000';
    Created: Date = new Date();
    Updated: Date = new Date();
    Deleted: boolean = false;
}